import Vue from 'vue';

const ppp = new Vue({
    data(){
        return{
            ppp:true
        }
    }
});

export default ppp


// WEBPACK FOOTER //
// ./src/router/ppp.js